import React from "react";

import DesktopTitle from "../DesktopTitle";
import HeaderTitle, { HeaderTitleProps } from "../HeaderTitle";

interface PageTitleProps extends Pick<HeaderTitleProps, "hideBackButton"> {}

const PageTitle: React.FC<PageTitleProps> = ({ children, hideBackButton = false }) => {
  return (
    <>
      <HeaderTitle hideBackButton={hideBackButton}>{children}</HeaderTitle>
      <DesktopTitle>{children}</DesktopTitle>
    </>
  );
};

export default PageTitle;
